const CloseSVG = () => (
    <svg 
        className="w-6 h-6" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M6 18L18 6M6 6l12 12"
        />
    </svg>
);

const ProjectModal = ({ isOpen, onClose, project }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-75 flex justify-center items-center p-4 transition-opacity duration-300" 
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto transform transition-all duration-300 scale-100" 
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="p-6 sm:p-8">
          <div className="flex justify-between items-start mb-6 border-b pb-4">
            <h2 className="text-3xl font-extrabold text-gray-900">
              {project.title}
            </h2>
            <button 
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition duration-150 p-1 rounded-full hover:bg-gray-100"
              aria-label="Close project details"
            >
              <CloseSVG />
            </button>
          </div>

          <div className="space-y-6">

            <img 
              src={project.image[0]} 
              alt={`${project.title} main view`} 
              className="w-full max-h-96 object-contain rounded-lg border border-gray-200"
            />

            {/* {project.image.length > 1 && (
              <div className="flex flex-wrap gap-2 justify-center pt-2">
                {project.image.slice(1).map((imgSrc, index) => (
                  <img 
                    key={index} 
                    src={imgSrc} 
                    alt={`${project.title} screenshot ${index + 2}`} 
                    className="w-24 h-16 object-cover rounded-md cursor-pointer hover:opacity-80 transition"
                  />
                ))}
              </div>
            )} */}

            <div>
              <h3 className="text-xl font-bold text-crimson mb-2">
                Project Overview
              </h3>
              <p className="text-gray-700 whitespace-pre-wrap">
                {project.description}
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-crimson mb-2">
                Key Technologies
              </h3>
              <div className="flex flex-wrap gap-2">
                {project.category && project.category.map((tag, index) => (
                  <span 
                    key={index} 
                    className="px-4 py-1 text-sm font-medium text-gray-800 bg-gray-200 rounded-full shadow-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            
            {(project.liveLink || project.repoLink) && (
              <div className="flex gap-4 pt-4 border-t">
                {project.liveLink && (
                  <a 
                    href={project.liveLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
                  >
                    View Live Project
                  </a>
                )}
                {project.repoLink && (
                  <a 
                    href={project.repoLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="bg-gray-700 text-white font-semibold px-6 py-2 rounded-lg shadow-md hover:bg-gray-800 transition duration-300"
                  >
                    View Code (Repo)
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal